//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
export default {
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  data: function data() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var self = this;
    return {
      index: 0,
      swiperOptions: {
        loop: false,
        direction: 'horizontal',
        autoplay: false,
        speed: 800,
        slidesPerView: 'auto',
        on: {
          slideChangeTransitionEnd: function slideChangeTransitionEnd() {
            self.index = this.realIndex;
          }
        }
      }
    };
  }
};